import { Helmet } from 'react-helmet-async';

const COMPANY_SYSTEM_TITLES = {
  FM: '福蒙系統',
  HC: '華辰系統',
};

export const getCompanySystemTitle = () => {
  const company = (sessionStorage.getItem('company') || '').trim().toUpperCase();

  return COMPANY_SYSTEM_TITLES[company] || '華辰系統';
};

export default function CompanySystemTitle() {
  const title = getCompanySystemTitle();

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}
